import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/NodeContainer/NodeContainer.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import { useStore, useStoreMap } from 'effector-react';
import { memo, useCallback, useMemo } from 'react';
import { isReferenceNode } from "../../../classifier-service/Node";
import { apiToNodeTypeMap } from "../../../classifier-service/adapters";
import { NodeRender } from "../NodeRender";
import { isTreeBimNode } from "../types";
import { useTreeNode } from "../useTreeNode";
import { useDependencyData } from "../useDependencyData";
import { buildKeyByPath, populateReference, getParentsByPath } from "../utils";
import { buildTreeItemKey } from "../buildTreeItemKey";
import { jsx as _jsx } from "react/jsx-runtime";
export var NodeContainer = /*#__PURE__*/memo(function (_ref) {
  var item = _ref.item,
      nodes$ = _ref.nodes$,
      isExpanded = _ref.isExpanded,
      toggle = _ref.toggle,
      onDroppedToGroup = _ref.onDroppedToGroup,
      canDropToGroup = _ref.canDropToGroup,
      onDroppedAfter = _ref.onDroppedAfter,
      onDroppedBefore = _ref.onDroppedBefore,
      canDropAfter = _ref.canDropAfter,
      canDropBefore = _ref.canDropBefore,
      renderNodeLayout = _ref.renderNodeLayout,
      onChecked = _ref.onChecked,
      checkbox = _ref.checkbox,
      inEdit = _ref.inEdit,
      onCancelCreating = _ref.onCancelCreating,
      onSubmitCreating = _ref.onSubmitCreating,
      onCancelEditing = _ref.onCancelEditing,
      onSubmitEditing = _ref.onSubmitEditing,
      searchNodes = _ref.searchNodes,
      onPending = _ref.onPending,
      selectedPath = _ref.selectedPath,
      onLoadMore = _ref.onLoadMore,
      dynamicMode = _ref.dynamicMode,
      isSpecialNode = _ref.isSpecialNode,
      highlightItem = _ref.highlightItem,
      dependenciesWithModels$ = _ref.dependenciesWithModels$,
      onSearchSource = _ref.onSearchSource,
      searchMatched$ = _ref.searchMatched$,
      currentEntity = _ref.currentEntity,
      readonly = _ref.readonly;
  //TODO разобраться с типами
  var node = useTreeNode({
    nodes$: nodes$,
    item: item
  });
  var searchMatched = useStore(searchMatched$, {
    loc: {
      file: _effectorFileName,
      line: 133,
      column: 26
    },
    name: "NodeContainer",
    sid: "NodeContainer /src/classifier-editor/ClassifierTree/NodeContainer/NodeContainer.tsx [133, 26]"
  });
  var inSearch = useMemo(function () {
    if (!searchNodes || !searchNodes.nodes.length || !node || node.type === 'CreateNode') {
      return {
        fullMatch: false,
        matched: false,
        source: false
      };
    }

    if (node.type === 'LoadMore') {
      var parentNode = node.parentNode;
      var fullMatchedKeys = Object.keys(searchMatched).filter(function (value) {
        return searchMatched[value] === 'fullMatch';
      });

      if (parentNode.type === 'DynamicGeneratedGroupNode' && parentNode.source && parentNode.source.type !== 'UserClassifierGroup') {
        var searchedNodeExists = parentNode.children.some(function (node) {
          return fullMatchedKeys.some(function (key) {
            return key === buildTreeItemKey(node);
          });
        });
        return {
          fullMatch: false,
          matched: !searchedNodeExists && searchMatched[buildTreeItemKey({
            id: parentNode.source.id,
            type: apiToNodeTypeMap[parentNode.source.type]
          })] === 'match',
          source: false
        };
      }

      if (!fullMatchedKeys.length) {
        return {
          fullMatch: false,
          matched: false,
          source: false
        };
      }

      if (node.parentNode.type === 'BimStandardSizeNode' || node.parentNode.type === 'UserClassifierGroupNode' && node.parentNode.groupType === 'WithElements') {
        var _searchedNodeExists = node.parentNode.children.some(function (node) {
          return fullMatchedKeys.some(function (key) {
            return key === buildTreeItemKey(node);
          });
        });

        return {
          fullMatch: false,
          matched: !_searchedNodeExists && searchMatched[buildTreeItemKey(node.parentNodeRef)] === 'match',
          source: false
        };
      }
    }

    return {
      matched: searchMatched[item.path[item.path.length - 1]] === 'match',
      fullMatch: searchMatched[item.path[item.path.length - 1]] === 'fullMatch',
      source: false
    };
  }, [item.path, node, searchMatched, searchNodes]);
  var parentNodes = useStoreMap({
    store: nodes$,
    keys: [item.path],
    fn: function fn(nodes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          itemPath = _ref3[0];

      return getParentsByPath(nodes, itemPath);
    }
  });
  var reference = useStoreMap({
    store: nodes$,
    keys: [node],
    fn: function fn(nodes, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          node = _ref5[0];

      var ref = parentNodes.find(isReferenceNode);

      if (node && isTreeBimNode(node) && ref) {
        return populateReference(nodes, ref);
      }

      if ((node === null || node === void 0 ? void 0 : node.type) === 'DynamicReferenceNode') {
        return node;
      }

      return (node === null || node === void 0 ? void 0 : node.type) === 'ReferenceNode' ? node : null;
    }
  });
  var dependencyData = useDependencyData({
    dependenciesWithModels$: dependenciesWithModels$,
    reference: reference,
    node: (node === null || node === void 0 ? void 0 : node.type) === 'ReferenceNode' ? node.element : node,
    currentEntity: currentEntity
  });
  var isSelected = !!(buildKeyByPath((selectedPath === null || selectedPath === void 0 ? void 0 : selectedPath.path) || []) === buildKeyByPath(item.path));
  var onExpandClick = useCallback(function () {
    if (node && node.type !== 'CreateNode' && node.type !== 'LoadMore') {
      toggle(node);
    }
  }, [node, toggle]);

  if (!node) {
    return null;
  }

  var highlighted = !!highlightItem && buildKeyByPath(highlightItem) === buildKeyByPath(item.path);
  return /*#__PURE__*/_jsx(NodeRender, {
    dynamicMode: dynamicMode,
    parentNodes: parentNodes,
    isExpanded: isExpanded,
    node: node,
    treeItem: item,
    inEdit: inEdit,
    path: item.path,
    onDoubleClickNode: onExpandClick,
    onExpandClick: onExpandClick,
    checkbox: checkbox,
    onDroppedToGroup: onDroppedToGroup,
    canDropToGroup: canDropToGroup,
    onDroppedAfter: onDroppedAfter,
    onDroppedBefore: onDroppedBefore,
    canDropAfter: canDropAfter,
    canDropBefore: canDropBefore,
    onCheckedNode: onChecked,
    renderNodeLayout: renderNodeLayout,
    onSubmitCreating: onSubmitCreating,
    onCancelCreating: onCancelCreating,
    onSubmitEditing: onSubmitEditing,
    onCancelEditing: onCancelEditing,
    inSearch: inSearch,
    onPending: onPending,
    isSelected: isSelected,
    onLoadMore: onLoadMore,
    isSpecialNode: isSpecialNode,
    highlighted: highlighted,
    dependencyData: dependencyData,
    onSearchSource: onSearchSource,
    readonly: readonly
  });
});